<template>
  {{ instance_vars }}
</template>

<script setup>
  defineProps(["instance_vars"]);
</script>
